<template>
    <div style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
        <el-form ref="form" :model="form2" label-width="180px">
            <el-form-item label="支付宝" class="grid-content bg-purple-dark">
            </el-form-item>
            <el-form-item label="商家支付宝账号：">{{alipay_account}}</el-form-item>

        </el-form>


    </div>


</template>
<style>

    .bg-purple-dark {
        background: #e5e9f2;
    }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
    export default {
        name: "child3",
        props: ["agentid_f3"],
        components: { },
        data() {
            return {
                alipay_account:'',
                loading: false,
                oneagent: {},
                form2: {},
                editFormVisible: false
            };
        },
        mounted() {
            this.getTableData();
        },
        methods: {
            getTableData() {
                var formData4 = new FormData() // 声明一个FormData对象
                formData4.append("agentid",this.agentid_f3);
                agentService.getPerfectAgent(formData4).then(data => {
                    if(data!=null && data!=""){



                        this.alipay_account=data.alipay_account;


                    }
                });
            }
        }
    };
</script>